import create from 'zustand';
import { NonAbapQueryState } from './interfaces/CreateQueryState';
import { createCommonNonAbapQuerySlice } from './slices/NonAbapQuerySlices/CommonNonAbapQuerySlice';

export const useNonAbapQueryStore = create<NonAbapQueryState>((set) => ({
  ...createCommonNonAbapQuerySlice(set)
}));
